import { createDefaultLogger } from '@moojo/logger'
import { knownPublishers } from '@moojo/shared-config'

import { ConvoAgentCore } from './core/convo-agent-core'
import { DOMUtils } from './lib/dom-utils'

/**
 * Entry point of convo-ad.
 */
;(async function (_window, document) {
  const logger = createDefaultLogger('[MoojoConvoAgent]')

  const domUtils = new DOMUtils(document)
  const { moojo: moojoParam } = domUtils.getSearchParams('moojo')

  const isPublishedEnabled = () => {
    const hostname = document.location.hostname
    const match = knownPublishers.find(p => hostname.includes(p.domain))
    const isForced = Boolean(moojoParam)
    if (match) {
      return { isEnabled: isForced || match.isEnabled, publisher: match.slug }
    }

    return { isEnabled: isForced, publisher: undefined }
  }

  try {
    const { isEnabled, publisher } = isPublishedEnabled()
    if (!isEnabled) {
      return
    }

    const requestedAdId = moojoParam === 'on' ? undefined : moojoParam
    await ConvoAgentCore.load(logger, publisher, document, requestedAdId)
  } catch (error) {
    logger.error('Error while starting', error)
  }
})(window, document)
